if (!customElements.get('editable-liftoff-progress')) {
  class EditableLiftoffProgress extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[data-elp-tab]');
        if (!tab || !this.contains(tab)) return;
        this.showStage(tab.dataset.elpTab, true);
      });

      this.addEventListener('keydown', (event) => {
        if (!(event.target instanceof Element)) return;
        const currentTab = event.target.closest('[data-elp-tab]');
        if (!currentTab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        const tabs = [...this.querySelectorAll('[data-elp-tab]')];
        const currentIndex = tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        event.preventDefault();
        this.showStage(tabs[nextIndex].dataset.elpTab, true);
      });

      this.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof Element)) return;
        const panel = event.target.closest('[data-elp-panel]');
        if (panel) this.showStage(panel.dataset.elpPanel, false);
      });

      if (!this.querySelector('[data-elp-tab][aria-selected="true"]')) {
        const firstTab = this.querySelector('[data-elp-tab]');
        if (firstTab instanceof HTMLElement) this.showStage(firstTab.dataset.elpTab, false);
      }
    }

    /**
     * @param {string | undefined} stageId
     * @param {boolean} focusTab
     */
    showStage(stageId, focusTab) {
      if (!stageId) return;

      this.querySelectorAll('[data-elp-tab]').forEach((tab) => {
        const isActive = tab.dataset.elpTab === stageId;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        if (isActive && focusTab && tab instanceof HTMLElement) {
          tab.focus({ preventScroll: true });
          const tabs = tab.parentElement;
          if (tabs && tabs.scrollWidth > tabs.clientWidth) {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            tabs.scrollTo({
              left: tab.offsetLeft - tabs.offsetLeft - (tabs.clientWidth - tab.offsetWidth) / 2,
              behavior: reduceMotion ? 'instant' : 'smooth',
            });
          }
        }
      });

      this.querySelectorAll('[data-elp-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.elpPanel !== stageId;
      });
    }
  }

  customElements.define('editable-liftoff-progress', EditableLiftoffProgress);
}
